export const isEmptyPartnersList = (ec) => {
  return ec.partners === undefined || ec.partners.length === 0;
};
